import { TV_SPOT_IDS } from '../data/tvSpotLocation';

/** テレビ表示の中心時間帯（9〜19時） */
const TV_HOURS = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

/** 古い町並み：API値が平坦なときの日内うねり（13〜14時ピーク） */
const OLD_TOWN_HOUR_WEIGHT = {
  9: 0.76,
  10: 0.8,
  11: 0.86,
  12: 0.93,
  13: 1,
  14: 1,
  15: 0.95,
  16: 0.88,
  17: 0.82,
  18: 0.76,
  19: 0.64,
};

const OLD_TOWN_LEVEL_FACTOR = 0.52;

const parseIsoDate = (iso) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
};

const dayVariationFactor = (iso) => {
  if (!iso) return 1;
  const dt = parseIsoDate(iso);
  const weekday = dt.getDay();
  const weekendBoost = weekday === 0 || weekday === 6 ? 1.06 : 1;
  const dateWobble = 0.94 + (dt.getDate() % 5) * 0.025;
  return weekendBoost * dateWobble;
};

const isFlatHourlyMap = (hourlyMap) => {
  const vals = TV_HOURS.map((h) => hourlyMap[h] || 0).filter((v) => v > 0);
  if (vals.length < 2) return true;
  if (Math.max(...vals) - Math.min(...vals) < 2) return true;

  // 19時だけ低いなど、日中帯が同一値のケース
  const dayHours = TV_HOURS.filter((h) => h !== 19);
  const dayVals = dayHours.map((h) => hourlyMap[h] || 0).filter((v) => v > 0);
  if (dayVals.length >= 4 && Math.max(...dayVals) - Math.min(...dayVals) < 2) return true;

  return false;
};

const clampLevel = (v) => Math.min(16, Math.max(4, Math.round(v)));

/**
 * 古い町並み：平坦なAPI値を時間帯・日ごとの自然なばらつきに展開
 * 駅前は生値のまま
 */
export const calibrateHourlyMapForTvSpot = (locationId, hourlyMap, { iso } = {}) => {
  if (!hourlyMap || locationId !== TV_SPOT_IDS.OLD_TOWN) return hourlyMap ?? {};

  const positives = TV_HOURS.map((h) => hourlyMap[h] || 0).filter((v) => v > 0);
  if (!positives.length) return {};

  const dayBase = positives.reduce((a, b) => a + b, 0) / positives.length;
  const level = dayBase * OLD_TOWN_LEVEL_FACTOR;
  const flat = isFlatHourlyMap(hourlyMap);
  const dayFactor = dayVariationFactor(iso);

  const out = {};
  TV_HOURS.forEach((h) => {
    const raw = hourlyMap[h] || 0;
    if (raw <= 0) {
      out[h] = 0;
      return;
    }

    if (flat) {
      const weight = OLD_TOWN_HOUR_WEIGHT[h] ?? 0.88;
      out[h] = clampLevel(level * weight * dayFactor);
      return;
    }

    const scaled = raw * OLD_TOWN_LEVEL_FACTOR * dayFactor;
    const weight = OLD_TOWN_HOUR_WEIGHT[h] ?? 1;
    out[h] = clampLevel(scaled * (0.85 + weight * 0.15));
  });

  return out;
};
